<div class="fx-row-w-100 fx-center fx-gap-15">
  <mat-form-field appearance="outline" floatLabel="always" class="mr-10">
    <mat-label>Parent Company Name</mat-label>
    <mat-select [multiple]="true" [formControl]="parentCompanyCtrl">
      <mat-option *ngFor="let parentCompany of parentCompanies" [value]="parentCompany.value">
        {{ parentCompany.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <button color="primary" class="form-action-button"
          mat-raised-button (click)="runFilter()"
          [disabled]="!!(loading$ | async)">Filter</button>
</div>
<app-crud-table
  [loading$]="loading$"
  [modelType]="mriBulkDownloadType"
  [subTitle]="'MRI Upload for Offering'"
  [tableData]="mriReport"
  [title]="'MRI Upload'"
>
</app-crud-table>
